// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Minus: React.FC<{ width?: number; height?: number }> = ({ width = 11, height = 2 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 2">
            <path
                fill="currentColor"
                d="M0 1c0-.563.344-1 .786-1h9.428c.442 0 .786.438.786 1 0 .563-.344 1-.786 1H.786C.344 2 0 1.562 0 1Z"
            />
        </svg>
    );
};

export default React.memo(Minus);
